@if (order) {
<div class="padding-large m-padding">
	<div class="page-layout-small">
		<bt-page-header title="Order information" subtitle="Shooting dates, warehouse and contacts of the order" icon="fa-solid fa-dolly">
		</bt-page-header>
		<div class="flex column border radius margin-top">
			@if (!isNew) {
			<div class="bg-lightest-blue padding-large m-padding">
				<div class="grid-filter">
					<div class="flex column">
						<b>Order ID</b>
						<div class="margin-top-smallest bg-white padding-small">
							<h4>{{ order?.id }}</h4>
						</div>
					</div>

					<div class="flex column">
						<b>Status</b>
						<div class="flex margin-top-smallest">
							<div class="flex-1 bg-white padding-small">
								<h4 class="normal primary">{{ order?.status?.name }}</h4>
							</div>
						</div>
					</div>

					<div class="flex column">
						<b>BasicNet ID</b>
						<div class="margin-top-smallest bg-white padding-small">
							<h4>{{ order?.basicNetId ?? '-' }}</h4>
						</div>
					</div>
				</div>
			</div>
			}

			<div class="padding-large m-padding">
				<div class="grid-filter">
					<div class="flex-1 flex column">
						<div class="flex center between">
							<b>
								Photographer @if (!orderValidation.photographer) {
								<span class="red margin-left">Required field</span>
								}
							</b>
						</div>
						<div class="border blue padding flex center margin-top-smallest">
							<div class="placeholder bg-primary white">
								<i class="fa fa-user"></i>
							</div>
							<div class="flex column margin-left-small">{{ order?.photographer?.fullName }}</div>
						</div>

						<div class="flex column margin-top">
							<b>Creation date</b>
							<div class="flex margin-top-smallest border padding-small">{{ order?.creationDate | date: 'MM-dd-yyyy' }}</div>
						</div>

						<div class="flex column margin-top">
							<b>Order type</b>
							<div class="flex center margin-top-smallest">
								<div class="flex gap center">
									@for (type of orderTypes; track type) {
									<div class="flex center column {{ type.selected ? 'border bg-lightest-blue' : '' }} padding-small  ">
										<div class="flex-1">
											<div class="placeholder {{ type.name }}"></div>
										</div>

										<div class="flex-0 flex column margin-top-smallest">
											<b>{{ type.name }}</b>
										</div>
									</div>
									}
								</div>
							</div>
						</div>

						<div class="flex column margin-top">
							<b>
								Due date @if (!orderValidation.dueDate) {
								<span class="red margin-left">Required field</span>
								}
							</b>
							<div class="flex margin-top-smallest border padding-small">{{ order?.dueDate | date: 'MM-dd-yyyy' }}</div>
						</div>
					</div>
					<div class="flex-1 flex column">
						<b>Notes</b>
						<div class="border padding-small full-height margin-top-smallest">{{ order?.notes }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
} @if (loading) {
<bt-loader></bt-loader>
}
